module.exports = __webpack_public_path__ + "img/img1_12.4efe9d64.jpeg";